import { render, staticRenderFns } from "./TheBox.vue?vue&type=template&id=c3605a48&scoped=true"
import script from "./TheBox.vue?vue&type=script&lang=ts"
export * from "./TheBox.vue?vue&type=script&lang=ts"
import style0 from "./TheBox.vue?vue&type=style&index=0&id=c3605a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3605a48",
  null
  
)

export default component.exports